<template>
  <div class="subscription-note">
    <span
      >The SoR membership subscription year runs from the 1st of October to the
      30th of September each year.</span
    >
  </div>
</template>

<script>
import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
  },
});
</script>

<style lang="scss" scoped>
.subscription-note {
  background: rgba(39, 91, 155, 0.1);
  border: 1px solid rgba(39, 91, 155, 0.1);
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  color: var(--body-light);
  line-height: 28px;
  margin-bottom: 16px;
  padding: 24px;
  text-align: center;

  span {
    &:first-of-type {
      font-size: 18px;

      b {
        color: var(--primary);
      }
    }

    &:last-of-type {
      font-size: 14px;
    }
  }
}
</style>
